export default __webpack_public_path__ + "static/media/to.5f7ede66.svg";